<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información de la Localidad">
          <b-form>
            <app-pais
              label="Pais"
              :nombre="paisNombre"
              :lista="paisesList"
              :valido="paisValido"
              :msjInvalido="paisInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="paisActualizado">
            </app-pais>  

            <app-provincia
              label="Provincia"
              :nombre="provinciaNombre"
              :lista="provinciasList"
              :valido="provinciaValida"
              :msjInvalido="provinciaInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="provinciaActualizada">
            </app-provincia>  

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Pais from '../shared/abmSelect.vue';
import Provincia from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'localidad/getField',
  mutationType: 'localidad/updateField',
});

export default {
  name: 'LocalidadABM',
  components: {
    appPais: Pais,
    appProvincia: Provincia,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      paisValido: null,
      paisInvalidoMsj: '',
      provinciaValida: null,
      provinciaInvalidaMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',

      paises: [],
      paisesList: [],
      provincias: [],
      provinciasList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'pais',
      'paisNombre',
      'provincia',
      'provinciaNombre',
      'nombre',
    ])
  },  
  created() {
    let localidadId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        localidadId = this.$route.params.id;
      }
    }

    this.loadingPaises = true;
    this.showSpinner();
    this.$store.dispatch('localidad/inicializar', localidadId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          vm.paises = this.$store.getters['paises/paisesSelect'];
          vm.paisesList = this.$store.getters['paises/listSelect'];
          vm.loadingPaises = false;
          return;
        })
        .then (() => this.getProvincias())
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de paises.'));
    },
    getProvincias() {
      this.provincias = [];
      this.provinciasList = [];

      if (this.paisNombre)
      {
        let pais = this.getSelected(this.paises, this.paisNombre);
        if (pais)
        {
          this.$store.dispatch('provincias/getList', pais.id)
            .then(() => {
              this.provincias = this.$store.getters['provincias/list']
              this.provinciasList = this.$store.getters['provincias/selectList']
              this.loadingProvincias = false;
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'El nombre es un campo obligatorio.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let provincia = null;
      if (this.provinciaNombre) {
        provincia = this.getSelected(this.provincias, this.provinciaNombre);
      }
      this.$store.dispatch('localidad/setProvincia', provincia);

      let provinciaError = true;
      if (this.provincia) {
        if (this.provincia.id){
          if (this.provincia.id != 0){
            provinciaError = false;
          }
        }
      }

      if (provinciaError) {
        this.provinciaValida = false;
        this.provinciaInvalidaMsj = "Debe seleccionar la provincia correspondiente."
        save = false;
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('localidad/save')
            .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: "Localidades" });
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        this.paisNombre = paisNombre;
        this.provinciaNombre = null;
        this.getProvincias();
        
        this.paisValido = null;
        this.paisInvalidoMsj = '';
      }
    },
    provinciaActualizada(provinciaNombre) {
      this.provinciaNombre = provinciaNombre;
    },
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
